import { c as _c } from "react/compiler-runtime";
import { Tooltip, centsToUnits } from '@systemeio/ui';
import { useAffiliateDashboardInvoices } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-invoices';
import { AffiliateDashboardFilterInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { AffiliateDashboardInvoicesInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-invoices-interface';
import { InvoiceStateEnum, InvoiceStateTitle } from 'modules/payment/invoices/enums/invoice-state-enum';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useDownloadInvoiceLink } from 'shared/hooks/use-download-invoice-link';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { currencyFormat } from 'shared/utils/currency-format';
import { dateFormat, dateTimeFormat } from 'shared/utils/date-time-format';
import { InvoiceDetailsModal } from '../../payment/invoices/components/invoice-details-modal';
import { QuestionMarkIcon } from '@systemeio/ui/icons';
interface AffiliateDashboardInvoicesProps {
  mainFilter: AffiliateDashboardFilterInterface;
  setMainFilter: React.Dispatch<React.SetStateAction<AffiliateDashboardFilterInterface>>;
}
const AffiliateDashboardInvoices = t0 => {
  const $ = _c(73);
  const {
    mainFilter,
    setMainFilter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const router = useRouter();
  const purchaseInvoiceId = router.query.purchaseInvoiceId as string;
  const {
    limit,
    setLimit,
    pagination,
    setPagination,
    clearPagination
  } = usePagination(true);
  const [invoiceId, setInvoiceId] = useState(null);
  let t1;
  let t2;
  if ($[0] !== purchaseInvoiceId) {
    t1 = () => {
      if (!isNaN(Number(purchaseInvoiceId))) {
        setInvoiceId(Number(purchaseInvoiceId));
      }
    };
    t2 = [purchaseInvoiceId];
    $[0] = purchaseInvoiceId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const getDownloadInvoiceLink = useDownloadInvoiceLink();
  let t3;
  if ($[3] !== limit || $[4] !== mainFilter || $[5] !== pagination) {
    t3 = {
      filter: mainFilter,
      pagination,
      limit
    };
    $[3] = limit;
    $[4] = mainFilter;
    $[5] = pagination;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    affiliateInvoices,
    counter
  } = useAffiliateDashboardInvoices(t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setInvoiceId(null);
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const closeModal = t4;
  let t5;
  if ($[8] !== clearPagination) {
    t5 = () => {
      clearPagination();
    };
    $[8] = clearPagination;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== clearPagination || $[11] !== mainFilter) {
    t6 = [clearPagination, mainFilter];
    $[10] = clearPagination;
    $[11] = mainFilter;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t5, t6);
  let t7;
  if ($[13] !== t) {
    t7 = t("dashboard.affiliate.amount");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== setMainFilter || $[16] !== user?.dashboardLocale) {
    t8 = invoice => <div className="flex items-center gap-1.5">{invoice.user.affiliateProgramBrandName ? <Tooltip label={invoice.user.affiliateProgramBrandName} mode="hover"><button onClick={() => setMainFilter(prev => ({
          ...prev,
          vendorId: invoice.user.id
        }))} className="ring-brand-primary shrink-0 rounded-full outline-hidden ring-offset-2 focus-visible:ring-2"><img alt={invoice.user.affiliateProgramBrandName} className="h-[32px] w-[32px] rounded-full" src={invoice.user.avatar} /></button></Tooltip> : <button onClick={() => setMainFilter(prev_0 => ({
        ...prev_0,
        vendorId: invoice.user.id
      }))} className="ring-brand-primary shrink-0 rounded-full outline-hidden ring-offset-2 focus-visible:ring-2"><img alt={invoice.user.affiliateProgramBrandName} className="h-[32px] w-[32px] rounded-full" src={invoice.user.avatar} /></button>}<span>{currencyFormat(centsToUnits(invoice.invoice.amount), invoice.invoice.currency, user?.dashboardLocale)}</span></div>;
    $[15] = setMainFilter;
    $[16] = user?.dashboardLocale;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = {
      key: "invoice",
      header: t7,
      widthPercent: 30,
      onRender: t8
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("dashboard.affiliate.state.label");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== invoiceId || $[24] !== t) {
    t11 = invoice_0 => <div className="flex gap-1"><span>{t(InvoiceStateTitle[invoice_0.invoice.state])}</span>{invoice_0.invoice.state === InvoiceStateEnum.unpaid && <QuestionMarkIcon className={`${!!invoiceId ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[18px] w-[18px] cursor-pointer`} onClick={() => {
        setInvoiceId(invoice_0.id);
      }} />}</div>;
    $[23] = invoiceId;
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = {
      key: "invoice",
      header: t10,
      widthPercent: 50,
      onRender: t11
    };
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("global.date");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== user?.dateFormat || $[32] !== user?.timeFormat || $[33] !== user?.timezone) {
    t14 = invoice_1 => <Tooltip wrapperClassName="w-full" mode="hover" label={dateTimeFormat(invoice_1.invoice.date, {
      timeFormat: user?.timeFormat,
      dateFormat: user?.dateFormat,
      timeZone: user?.timezone
    })}><span className="w-full truncate">{dateFormat(invoice_1.invoice.date, {
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })}</span></Tooltip>;
    $[31] = user?.dateFormat;
    $[32] = user?.timeFormat;
    $[33] = user?.timezone;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t13 || $[36] !== t14) {
    t15 = {
      key: "invoice",
      header: t13,
      widthPercent: 20,
      onRender: t14
    };
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t12 || $[39] !== t15 || $[40] !== t9) {
    t16 = [t9, t12, t15];
    $[38] = t12;
    $[39] = t15;
    $[40] = t9;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  const columns = t16;
  let t17;
  if ($[42] !== t) {
    t17 = t("dashboard.affiliate.invoices");
    $[42] = t;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t) {
    t18 = t("dashboard.affiliate.download_invoice");
    $[44] = t;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== getDownloadInvoiceLink) {
    t19 = invoice_2 => getDownloadInvoiceLink(invoice_2.id);
    $[46] = getDownloadInvoiceLink;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t18 || $[49] !== t19) {
    t20 = {
      openLink: [{
        caption: t18,
        name: "download-invoice",
        openInNew: true,
        setHref: t19
      }]
    };
    $[48] = t18;
    $[49] = t19;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== limit || $[52] !== setLimit) {
    t21 = {
      limit,
      setLimit
    };
    $[51] = limit;
    $[52] = setLimit;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== pagination || $[55] !== setPagination) {
    t22 = {
      pagination,
      setPagination
    };
    $[54] = pagination;
    $[55] = setPagination;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== affiliateInvoices || $[58] !== columns || $[59] !== t20 || $[60] !== t21 || $[61] !== t22) {
    t23 = <Table actions={t20} data={affiliateInvoices} columns={columns} limiter={t21} paginator={t22} />;
    $[57] = affiliateInvoices;
    $[58] = columns;
    $[59] = t20;
    $[60] = t21;
    $[61] = t22;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  let t24;
  if ($[63] !== affiliateInvoices || $[64] !== counter || $[65] !== t17 || $[66] !== t23) {
    t24 = <ListingLayout counter={counter} data={affiliateInvoices} title={t17} type="compact">{t23}</ListingLayout>;
    $[63] = affiliateInvoices;
    $[64] = counter;
    $[65] = t17;
    $[66] = t23;
    $[67] = t24;
  } else {
    t24 = $[67];
  }
  let t25;
  if ($[68] !== invoiceId) {
    t25 = <InvoiceDetailsModal invoiceId={invoiceId} onCloseModal={closeModal} />;
    $[68] = invoiceId;
    $[69] = t25;
  } else {
    t25 = $[69];
  }
  let t26;
  if ($[70] !== t24 || $[71] !== t25) {
    t26 = <>{t24}{t25}</>;
    $[70] = t24;
    $[71] = t25;
    $[72] = t26;
  } else {
    t26 = $[72];
  }
  return t26;
};
export default AffiliateDashboardInvoices;